import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-date-field',
  templateUrl: './date-field.component.html',
  styleUrl: './date-field.component.css',
})
export class DateFieldComponent implements ICellRendererAngularComp {
  formattedDate: string;
  currentField: any;
  params;
  dateToday: string;
  jan2004 = '2004-01-01'

  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params): void {
    const currentDate = new Date(); //Restrict date field from selecting past date
    this.dateToday = currentDate.toISOString().split('T')[0];
    this.params = params;
    this.currentField = this.params?.column?.colId;
    if (params.value) {
      const isoDate = this.toIsoDateString(params.value);
      this.params.data[this.currentField] = isoDate; // To be displayed on editable state
      this.formattedDate = this.formatDate(params.value); // To be displayed when non-editable state
    }
  }

  openDatePicker(event: Event) {
    const input = event.target as HTMLInputElement;
    input.showPicker?.();
    input.focus();
  }

  toIsoDateString(dateValue: any): string {
    const date = new Date(dateValue);
    return date.toISOString().split('T')[0]; // format YYYY-MM-DD
  }

  formatDate(value: string): string {
    if (!value) {
      return '';
    } else {
      const isoformattedDate = value.replace(' ', 'T');
      const parsedDate = new Date(isoformattedDate);
      if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
      } else {
        return new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC',
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
        }).format(parsedDate);
      }
    }
  }

  get displayDateValue(): string {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (this.params.data.editable && tempData) {
      return tempData[this.params.colDef.field];
    }
    return this.params.data[this.params.colDef.field];
  }

  onDateValueInput(newValue: string) {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (tempData) {
      tempData[this.params.colDef.field] = newValue; // Mutate temp state only
    }
  }
}
